<template lang="pug">
#modal-exportar-arquivo
    el-dialog(
        :title='$t("mensagens.preAnaliseCredito.exportarArquivo")',
        :width='width',
        :visible.sync='show',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        custom-class='no-box-shadow',
        @close='closeDialog()'
    )
        div(style='display: flex; flex-direction: column')
            span.modal-text(style='color: #00413c')
                | {{ $t('mensagens.preAnaliseCredito.consultaRealizada') }}
            .text-left
                span.font-bold {{ $t('mensagens.preAnaliseCredito.documento') }}:
                    span.font-weight-normal.ml-1
                        | {{ numeralStringFormatTocpfCnpj(dadosUsuarioModalExportar.cpfCnpj) }}
            .text-left(style='padding-bottom: 20px')
                span.font-bold {{ $t('mensagens.preAnaliseCredito.nome') }}:
                    span.font-weight-normal.ml-1
                        | {{ dadosUsuarioModalExportar.nome }}

            span.modal-text(style='color: #00413c')
                | {{ $t('mensagens.preAnaliseCredito.opcoesDeDownload') }}

            span.modal-text(style='color: #3b3b3b')
                | {{ $t('mensagens.preAnaliseCredito.exportarTudo') }}

            div(v-if='isPessoaFisica')
                el-checkbox(
                    :indeterminate='isIndeterminateCpf',
                    v-model='checkAllCpf',
                    @change='handleCheckAllChangeCpf'
                ) {{ $t('mensagens.preAnaliseCredito.exportarConsultaCompleta') }}
                el-divider(style='margin-bottom: 15px !important')
                el-checkbox-group(
                    v-model='checkedOpcoesCpf',
                    @change='handleCheckedOpcoesChangeCpf'
                )
                    el-checkbox(
                        v-for='itens in opcoesCpf',
                        :label='itens',
                        :key='itens'
                    ) {{ itens }}

            div(v-else)
                el-checkbox(
                    :indeterminate='isIndeterminateCnpj',
                    v-model='checkAllCnpj',
                    @change='handleCheckAllChangeCnpj'
                ) {{ $t('mensagens.preAnaliseCredito.exportarConsultaCompleta') }}
                el-divider(style='margin-bottom: 15px !important')
                el-checkbox-group(
                    v-model='checkedOpcoesCnpj',
                    @change='handleCheckedOpcoesChangeCnpj'
                )
                    el-checkbox(
                        v-for='itens in opcoesCnpj',
                        :label='itens',
                        :key='itens'
                    ) {{ itens }}

        .dialog-footer(slot='footer', v-if='mostrarBotaoVoltar')
            BaseButton(@click='closeDialog()') {{ $t('mensagens.comuns.cancelar') }}
            BaseButton(
                v-if='isPessoaFisica',
                type='primary',
                :disabled='checkedOpcoesCpf.length === 0',
                @click='$emit("exportar", checkedOpcoesCpf)'
            ) {{ $t('mensagens.comuns.exportar') }}
            BaseButton(
                v-else,
                type='primary',
                :disabled='checkedOpcoesCnpj.length === 0',
                @click='$emit("exportar", checkedOpcoesCnpj)'
            ) {{ $t('mensagens.comuns.exportar') }}
</template>

<script>
import formatters from '@/utils/formatters';
import BaseButton from './BaseButton.vue';

export default {
    name: 'BaseModalExportarArquivo',

    components: {
        BaseButton
    },

    props: {
        show: {
            type: Boolean,
            default: false,
            required: true
        },
        width: {
            type: String,
            default: '500px'
        },
        mostrarBotaoVoltar: {
            type: Boolean,
            default: true
        },
        isPessoaFisica: {
            type: Boolean,
            default: false
        },
        dadosUsuarioModalExportar: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            checkAllCpf: false,
            checkAllCnpj: false,
            checkedOpcoesCpf: [],
            checkedOpcoesCnpj: [],
            isIndeterminateCpf: false,
            isIndeterminateCnpj: false
        };
    },

    computed: {
        opcoesCpf() {
            return [
                this.$t('mensagens.preAnaliseCredito.modulos.dadosFinanceiros'),
                this.$t(
                    'mensagens.preAnaliseCredito.modulos.dadosFiscaisTributarios'
                ),
                this.$t(
                    'mensagens.preAnaliseCredito.modulos.informacoesProfissionais'
                ),
                this.$t(
                    'mensagens.preAnaliseCredito.modulos.informacoesPublicasBndes'
                ),
                this.$t('mensagens.preAnaliseCredito.modulos.patrimonio'),
                this.$t(
                    'mensagens.preAnaliseCredito.modulos.pessoaPoliticamenteExposta'
                ),
                this.$t(
                    'mensagens.preAnaliseCredito.modulos.processosJudiciais'
                ),
                this.$t('mensagens.preAnaliseCredito.modulos.relacionamentos'),
                this.$t('mensagens.preAnaliseCredito.modulos.sancoesRestricoes')
            ];
        },
        opcoesCnpj() {
            return [
                this.$t('mensagens.preAnaliseCredito.modulos.dadosFinanceiros'),
                this.$t('mensagens.preAnaliseCredito.modulos.dadosFiscais'),
                this.$t(
                    'mensagens.preAnaliseCredito.modulos.informacoesPublicasBndes'
                ),
                this.$t('mensagens.preAnaliseCredito.modulos.patrimonio'),
                this.$t(
                    'mensagens.preAnaliseCredito.modulos.processosJudiciais'
                ),
                this.$t('mensagens.preAnaliseCredito.modulos.relacionamentos'),
                this.$t('mensagens.preAnaliseCredito.modulos.sancoesRestricoes')
            ];
        }
    },

    methods: {
        closeDialog() {
            this.$emit('closeDialog');
        },
        handleCheckAllChangeCpf(val) {
            this.checkedOpcoesCpf = val ? this.opcoesCpf : [];
            this.isIndeterminateCpf = false;
        },
        handleCheckedOpcoesChangeCpf(value) {
            let checkedCount = value.length;
            this.checkAllCpf = checkedCount === this.opcoesCpf.length;
            this.isIndeterminateCpf =
                checkedCount > 0 && checkedCount < this.opcoesCpf.length;
        },
        handleCheckAllChangeCnpj(val) {
            this.checkedOpcoesCnpj = val ? this.opcoesCnpj : [];
            this.isIndeterminateCnpj = false;
        },
        handleCheckedOpcoesChangeCnpj(value) {
            let checkedCount = value.length;
            this.checkAllCnpj = checkedCount === this.opcoesCnpj.length;
            this.isIndeterminateCnpj =
                checkedCount > 0 && checkedCount < this.opcoesCnpj.length;
        },
        numeralStringFormatTocpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        }
    }
};
</script>

<style lang="scss">
#modal-exportar-arquivo {
    .el-dialog__footer {
        margin-top: 0px;
        text-align: right;
        border-top: solid 2px #e7e7e7;
        background-color: #ffffff;

        .dialog-footer {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }
    }

    .modal-text {
        font-family: 'Roboto', 'sans serif';
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        padding-bottom: 8px;
    }

    .el-dialog__body {
        max-height: 525px;
        overflow-y: auto;
    }

    .el-dialog__body {
        padding: 20px;
        background-color: #ffffff;
        padding-bottom: 0;
        span {
            color: #3b3b3b;
        }
    }

    .el-dialog__header {
        background-color: #e9e9e9;
        .el-dialog__title {
            color: #00413c;
            font-weight: 600;
            font-size: 18px;
            line-height: 22px;
        }
    }

    .font-bold {
        font-weight: 600;
    }

    .el-checkbox-group {
        display: flex;
        flex-direction: column;

        .el-checkbox {
            padding: 5px 0 5px 0;
            font-weight: 500;
        }
    }

    .el-divider--horizontal {
        margin: 15px 0 8px 0;
    }
}
</style>
